import { Link } from "react-router-dom";
import classes from "./Section1.module.css";
import { section1Data } from "../../../data/about";

export default function Section1() {
  return (
    <section className={classes.section}>
      <div className="container">
        <div className={classes.content}>
          <div className={classes.intro}>
            <span className={classes.eyebrow}>Who We Are</span>

            <h2 className={classes.title}>
              Our Commitment to{" "}
              <span className={classes.highlight}>Excellence</span>
            </h2>

            <p className={classes.description}>
              MITSI is passionate about innovating healthcare. Our solutions
              enhance providers and improve patient care. We aim for excellence,
              always promoting our services. Our team offers great support,
              ensuring satisfaction and advancing technology. Together, we are
              building a healthier future.
            </p>

            <Link to="/contact-us" className={`btn ${classes.button}`}>
              Discover More
            </Link>
          </div>

          <div className={classes.stats} aria-label="MITSI statistics">
            {section1Data.map(({ value, label, icon: Icon }) => (
              <article className={classes.statCard} key={label}>
                <span className={classes.icon} aria-hidden="true">
                  <Icon />
                </span>

                <div className={classes.statInfo}>
                  <strong className={classes.value}>{value}</strong>
                  <span className={classes.label}>{label}</span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
